import TennisTable from "./TennisTable";
export const firstTennisSection = [
  {
    name: "Row 1",
    left: [],
    right: [
      { column1: "Overall Size", column2: "340ft x 120ft" },
      { column1: "Total Area", column2: "41,760 sq.ft./4,640 sq.yds" },
      { column1: "Playing Area", column2: "19,656 sq.ft./2,184 sq.yds" },
      { column1: "Outside Court Area", column2: "22,104 sq.ft./2,456 sq.yds" },
    ],
  },
];

export const secondTennisSection = [
  {
    name: "Row 2",
    left: ["Acrylic Resurfacer", "Acrylic Resurfacer With Sand"],
    right: [
      { column1: "One Coat", column2: "325 Gallons" },
      { column1: "One Coat", column2: "515 Gallons" },
    ],
  },
];

export const thirdTennisSection = [
  {
    name: "Row 3",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "220 Gallons" },
      { column1: "Two Coats", column2: "310 Gallons" },
      { column1: "Two Coats", column2: "525 Gallons" },
    ],
  },
];

export const forthTennisSection = [
  {
    name: "Row 4",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "250 Gallons" },
      { column1: "Two Coats", column2: "310 Gallons" },
      { column1: "Two Coats", column2: "525 Gallons" },
    ],
  },
];

export const fifthTennisSection = [
  {
    name: "Row 5",
    left: ["CushionMaster II (Coarse Rubber)", "CushionMaster I (Fine Rubber)"],
    right: [
      { column1: "Three Coats", column2: "2090 Gallons" },
      { column1: "Two Coats", column2: "930 Gallons" },
    ],
  },
];

export const sixthTennisSection = [
  {
    name: "Row 6",
    left: ["Stripe Rite", "White Line Paint"],
    right: [
      { column1: "One Coat", column2: "7 Gallons" },
      { column1: "One Coat", column2: "7 Gallons" },
    ],
  },
];

export const sevenTennisSection = [
  {
    name: "Row 7",
    left: ["Standard Size Roll"],
    right: [{ column1: "56 Rolls" }],
    right: [{ column1: "56 Rolls" }],
  },
];

const TennisSevenCourt = () => {
  return (
    <>
      <TennisTable rows={firstTennisSection} hidden={true} />
      <TennisTable
        rows={secondTennisSection}
        leftCol={"Total Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={thirdTennisSection}
        leftCol={"Inside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={forthTennisSection}
        leftCol={"Outside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={fifthTennisSection}
        leftCol={"ProCushion LAYERS"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sixthTennisSection}
        leftCol={"STRIPING"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sevenTennisSection}
        leftCol={"MASKING TAPE"}
        middleCol={"Rolls Needed"}
      />
    </>
  );
};

export default TennisSevenCourt;
